import { classnames } from '@/helpers';
import { ElementType, ReactNode } from 'react';

type ContainerLayoutProps = {
  as?: ElementType;
  className?: string;
  innerClassName?: string;
  children: ReactNode;
   /**
   * If true, the inner container with padding will only apply on screens larger than 2xl, while the outer container will still center content and apply max-width. This is useful for layouts that should be full-width on smaller screens but constrained on large screens.
   */
  onlyAbove2xl?: boolean;
};

/**
 * outer is a size container (@container) with max width = theme('screens.2xl')
 * inner handles padding that adapts via viewport AND container queries
 */
export default function ContainerLayout({
  as: Component = 'div',
  className,
  innerClassName,
  children,
  onlyAbove2xl,
}: ContainerLayoutProps) {
  return (
    <Component
      className={classnames(
        '@container',
        onlyAbove2xl ? '2xl:mx-auto 2xl:max-w-screen-2xl' : 'mx-auto max-w-screen-2xl',
        className,
      )}>
      <div
        className={classnames(
          onlyAbove2xl ? '2xl:container-layout__inner' : 'container-layout__inner',
          innerClassName,
        )}>
        {children}
      </div>
    </Component>
  );
}
